import { useBreakpoints } from '@vueuse/core';
import { breakpoints as definedBreakpoints } from '@/styling/foundation/breakpoint';
import { computed } from 'vue';

export const breakpoints = useBreakpoints(definedBreakpoints);

export const isMobile = breakpoints.smaller('lg');
export const isSmallerThanXl = breakpoints.smaller('xl');
export const isSmallerThanMd = breakpoints.smaller('md');

export const PAGINATOR_TEMPLATE = computed(() => {
    if (isMobile.value) {
        return 'PrevPageLink PageLinks NextPageLink';
    }

    return 'CurrentPageReport PrevPageLink PageLinks NextPageLink RowsPerPageDropdown';
});
